import React from 'react';
import Commande from "../../components/commande";
import screens from "../../screens";
import {Get, Post} from "../../components/request";
import {Button} from "react-bootstrap";
import {faPlus} from "@fortawesome/pro-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {withRouter} from "react-router-dom";
import ScreenComponent from "../../components/screenComponent";
import Security from "../../components/security";
import {getRoute} from "../../breadcrumb/utils";
import InterventionConseilSocial from "./interventionConseilSocial";

class Commandes extends ScreenComponent {

    constructor(props) {
        super(props);
        this.state = {
            commandes: [],
            interventions: [],
            InterventionID: null,
            alreadyCalled: false,
        }
    }

    async componentDidMount() {
        super.componentDidMount();

        let {body} = await Get(`/v1/extranet/student/${screens.Commandes}`);
        let commandes = body.slice();

        await Promise.all(
            commandes.map(async (item) => {
                let {body} = await Get(`/v1/extranet/student/${screens.Commandes}01/${item.CommandeID}`);
                item.details = body;
            })
        );

        ({body} = await Get(`/v1/extranet/student/${screens.CommandesIntervention}`));
        const options = [];
        body.map(v => options.push({value: Number(v.CommandeID), label: v.CommandeDisplay, ...v}));

        this.setState({
            commandes: commandes,
            interventions: options,
        });
    }

    updateIntervention(value) {
        this.setState({
            InterventionID: value
        });
    }

    async createIntervention() {
        if (this.state.alreadyCalled) return;

        this.setState({
            alreadyCalled: true
        });

        var data = new FormData();
        data.append('CommandeID', this.state.InterventionID.value);

        console.log(data);

        await Post(`/v1/extranet/student/${screens.CommandesIntervention}`, Object.fromEntries(data), "Création en cours..", {render: "Intervention créée !"}, {render: "Erreur lors de la création"});

        this.setState({
            alreadyCalled: false,
            InterventionID: null,
        });

        this.componentDidMount();
    }

    render() {
        return (
            <>
                <section className="text-right">
                    {Security.canAccess(screens.NouvelleCommande)[0] &&
                        <Button onClick={() => this.props.history.push(getRoute(screens.NouvelleCommande))} size="lg"
                                variant="outline-primary">
                            <FontAwesomeIcon className="text-success" icon={faPlus}/>
                            <span className="ml-2">Nouvelle commande</span>
                        </Button>}
                </section>
                {this.state.commandes.map((item, key) => {
                    return (
                        <Commande key={key} {...item} />
                    );
                })}
                {this.state.interventions.length > 0 &&
                    <InterventionConseilSocial selected={this.state.InterventionID}
                                               onChange={this.updateIntervention.bind(this)}
                                               onCreate={this.createIntervention.bind(this)}
                                               commandes={this.state.interventions}/>
                }
            </>
        );
    }
}

export default withRouter(Commandes);